import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
import { useState, useEffect, useContext } from "react";
import { Loading, GainfulButton } from "CheckoutComponents";
import x from "Images/checkout/x.svg";
import info from "Images/checkout/info.svg";
import { CheckoutContext } from "Root/checkout/CheckoutRoutes";
import { apiGetSavedProgramDiscount } from "Root/api/apiCheckout";
import styles from "./styles.module.css";
import Tooltip from "@mui/material/Tooltip";
import { useDispatch } from "react-redux";
import { updateUserCart } from "Root/checkout/redux/slices/checkoutUserCartSlice";
function PromoComponent(props) {
    const dispatch = useDispatch();
    const [promo, setPromo] = useState("");
    const [savedDiscountProgram, setSavedDiscountProgram] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [errorInput, setErrorInput] = useState(false);
    const { promoErrorText, setUserCart } = useContext(CheckoutContext);
    useEffect(() => {
        if (promoErrorText !== null) {
            setError(promoErrorText);
        }
    }, [promoErrorText]);
    const fetchSavedProgram = async () => {
        const response = await apiGetSavedProgramDiscount();
        setSavedDiscountProgram(response.programStr);
    };
    const savedDiscountText = (_jsxs("span", { children: ["Your ", _jsx("span", { style: { color: "#77B1AC", fontWeight: 400, textTransform: "uppercase" }, children: savedDiscountProgram }), " ", "promo has been saved for your next order since you already have a promotion applied to your current order. If you want to use it now, please remove the current promo."] }));
    useEffect(() => {
        fetchSavedProgram();
    }, [props.discountStr]);
    function changePromo(e) {
        setErrorInput(false);
        setPromo(e.target.value);
    }
    function clickedApply() {
        if (props.isStarterKit === true) {
            setError("Discounts cannot be added to starter kit");
        }
        else {
            setLoading(true);
            props
                .applyPromo(promo)
                .then((resp) => {
                setLoading(false);
                setError(null);
                if (setUserCart && resp) {
                    setUserCart(resp.userCart);
                }
                if (resp) {
                    dispatch(updateUserCart(resp.userCart));
                }
                setPromo("");
            })
                .catch((thisError) => {
                setLoading(false);
                setErrorInput(true);
                setError(thisError.detail || thisError.message.replaceAll('"', ""));
            });
        }
    }
    function removePromoX(promoToRemove) {
        setLoading(true);
        props
            .removePromo(promoToRemove)
            .then(() => {
            setLoading(false);
            setError(null);
        })
            .catch(() => {
            setLoading(false);
        });
    }
    const buttonstyle = {
        flex: "1 1 102px",
        maxWidth: "154px",
        marginLeft: "18px",
    };
    if (props.isStarterKit === true) {
        props.setDiscountStr([]);
    }
    const applyedPromoBlock = props.discountStr !== null && (_jsxs("div", { className: styles.promoapplied, children: [savedDiscountProgram && _jsx("div", { className: styles.tobeapplied, children: "To be applied to this order:" }), props.discountStr.map((dstring) => (_jsxs("div", { className: styles.promoappliedcontainer, children: [_jsx("span", { className: styles.promoToken, children: dstring }), !dstring.includes(" Discount") && (_jsx("button", { type: "button", className: styles.promoxcontainer, onClick: () => {
                            removePromoX(dstring);
                        }, onKeyDown: () => {
                            removePromoX(dstring);
                        }, children: _jsx("img", { className: styles.promo_x, src: x, alt: "x" }) }))] }, dstring))), savedDiscountProgram && (_jsxs(_Fragment, { children: [_jsx("hr", { className: styles.hr }), _jsxs("div", { className: styles.tobeapplied, children: ["To be applied to subsequent orders:", _jsx(Tooltip, { title: savedDiscountText, style: { background: "#F5F5F5" }, children: _jsx("img", { className: styles.promo_info, src: info, alt: "info" }) })] })] })), savedDiscountProgram && (_jsx("div", { className: `${styles.promoappliedcontainer} ${styles.teal}`, children: _jsx("span", { className: styles.promoToken, children: savedDiscountProgram }) }, savedDiscountProgram))] }));
    return (_jsx(_Fragment, { children: loading ? (_jsx(Loading, {})) : (_jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsxs("div", { className: styles.container, children: [_jsx("input", { type: "text", placeholder: props.isGiftCard ? "Gift Card" : "Promo Code", value: promo, className: `${styles.input} ${errorInput && styles.errorInput}`, onChange: changePromo }), _jsx(GainfulButton, { text: "Apply", disabled: promo === "", onClick: () => clickedApply(), style: buttonstyle })] }), error && _jsx("div", { className: styles.error, children: error })] }), applyedPromoBlock] })) }));
}
export default PromoComponent;
